import React, { useId } from 'react';
import styles from './EditorEmptyBlockIcon.module.scss';

export const EditorEmptyBlockIcon: React.FC = () => {
  // we use random string generator for creating unique icon parts
  // cause of preventing unexpected behaviour in ui
  // Bug 60602: Fix Dashboard UI Editor blocks icons
  const uid = useId();
  const clipId = `clip-${uid}`;
  const patternId = `pattern-${uid}`;

  return (
    <svg
      className={styles.root}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id={clipId}>
          <rect x="4.5" y="6.5" width="19" height="15" />
        </clipPath>

        <pattern
          id={patternId}
          patternUnits="userSpaceOnUse"
          x="1.2"
          width="2"
          height="4"
          patternTransform="rotate(45)"
        >
          <line x1="0" y1="0" x2="0" y2="4" className={styles.stripe} />
        </pattern>
      </defs>

      <rect width="28" height="28" rx="2" className={styles.bg} />

      <g clipPath={`url(#${clipId})`}>
        <rect
          x="5"
          y="7"
          width="18"
          height="14"
          fill={`url(#${patternId})`}
          className={styles.fill}
        />
      </g>

      <rect
        x="4.5"
        y="6.5"
        width="19"
        height="15"
        fill="none"
        className={styles.frame}
      />
    </svg>
  );
};
